// The welcome offer while a flash sale pauses the welcome code (snippets/ns-welcome-paused.liquid): Liquid hides the offer
// ([data-ns-welcome-until], with the Unix second it comes back) and shows a plain line in its place ([data-ns-welcome-alt]).
// A page cached during the pause and opened after it, or left open past it, gets the offer back here. A grid marked
// [data-ns-welcome-cols] (the promo tiles) then sets --cols from the tiles it shows.

// until: the Unix second from the attribute. The offer is back at that second (an unreadable value shows it).
export function welcomeBack(until, nowSeconds) {
  const at = Number(until);
  return !(Number.isFinite(at) && at > 0 && at > nowSeconds);
}

// The promo grid's columns: the tiles not hidden, one or two.
export function welcomeCols(hidden) {
  return Math.min(2, Math.max(1, hidden.filter(flag => !flag).length));
}

if (typeof document !== 'undefined') {
  const settle = () => {
    const now = Date.now() / 1000;
    let next = Infinity;
    for (const node of document.querySelectorAll('[data-ns-welcome-until], [data-ns-welcome-alt]')) {
      const alt = node.hasAttribute('data-ns-welcome-alt');
      const until = node.getAttribute(alt ? 'data-ns-welcome-alt' : 'data-ns-welcome-until');
      if (!welcomeBack(until, now)) {
        next = Math.min(next, Number(until));
        continue;
      }
      if (alt) node.remove();
      else {
        node.hidden = false;
        node.removeAttribute('data-ns-welcome-until');
      }
    }
    for (const grid of document.querySelectorAll('[data-ns-welcome-cols]')) grid.style.setProperty('--cols', String(welcomeCols([...grid.children].map(child => child.hidden))));
    if (Number.isFinite(next)) setTimeout(settle, Math.min(2147483647, Math.max(1000, (next - now) * 1000)));
  };
  settle();
}
